<template>
  <b-row class="ticket-info-field align-items-start">
    <b-col cols="12" md="4" class="ticket-info-field__label-col pr-md-3 mb-2 mb-md-0">
      <div class="ticket-info-field__label">{{ label }}</div>
      <div v-if="$slots['label-append']" class="ticket-info-field__label-append">
        <slot name="label-append" />
      </div>
    </b-col>
    <b-col cols="12" md="8" class="ticket-info-field__value-col">
      <slot />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'TicketInfoFieldRow',
  props: {
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.ticket-info-field {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.ticket-info-field__label {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  color: #495057;
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .ticket-info-field__label {
    padding-top: 0.125rem;
  }
}

.ticket-info-field__label-append {
  margin-top: 0.5rem;
}
</style>
